import UA from '@ali/tbm-ua';
import { sendOther } from '@ali/tbm-log';
import { PerformanceLog } from '@ali/tbm-mini-perf';
import { report } from './report';

window.__monitor__ || (window.__monitor__ = {});

/**
 * Arms上报
 * @param apiName 上报名
 * @param params 上报参数
 */
export const armsReport = function (apiName, ...params) {
  try {
    if (!window.__monitor__.webLog) {
      window.__monitor__.webLog = report(
        window.__monitor__.sendGoldLog || sendOther,
        window.__monitor__
      );
    }
    window.__monitor__.webLog(apiName, ...params);
  } catch (e) {
    console.log('armsReport error:', e);
  }
};

/** 钢铁侠模块，负责初始化Arms */
export class IronMan {
  config: any;

  constructor(config = {}) {
    this.config = config;
    this.initConfig();
    this.initErrorListener();
  }

  initConfig() {
    window.__monitor__ = {
      ...window.__monitor__,
      ...this.config,
    };
  }

  cacheErrorHandle(e) {
    armsReport('error', e);
  }

  removeErrorEventListener() {
    window.removeEventListener('error', this.cacheErrorHandle.bind(this));
    window.removeEventListener(
      'unhandledrejection',
      this.cacheErrorHandle.bind(this)
    );
  }

  /**
   * 1、上报错误PV(一次PV，发生报错，只上报一次)
   * 2、补偿异步加载arms sdk期间的js错误
   */
  initErrorListener() {
    this.removeErrorEventListener();
    window.addEventListener('error', this.cacheErrorHandle.bind(this), true);
    window.addEventListener(
      'unhandledrejection',
      this.cacheErrorHandle.bind(this),
      true
    );
  }
}

/** 初始化Arms */
export function initArms(config?) {
  return new IronMan(config);
}

/**
 * 性能分析
 */
export const performanceAnalysis = new PerformanceLog({
  useAutoIndex: true,
  sendGoldLog: ({ logKey, logData } = {} as any) => {
    sendOther(logKey, logData);
  },
  logData: {
    os: UA.isIOS ? 'ios' : UA.isAndroid ? 'android' : 'unknown',
  },
});
